
<template>
   <v-layout row wrap>
      <v-flex xs12>
         <v-list>
            <template v-for="event in events">
            <v-list-tile :key="event.id">
               <v-list-tile-content>
                  <v-list-tile-title>{{ event.message.text }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ eventAuthorName(event) }}</v-list-tile-sub-title>
               </v-list-tile-content>
               <v-list-tile-action>
                  {{ formatDate(event.timestamp) }}
               </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
            </template>
         </v-list>

         <v-card v-if="events.length === 0">
            <v-card-text style="height: 100px;" class="Aligner">
               <v-icon>not_interested</v-icon>
            </v-card-text>
         </v-card>

      </v-flex>
   </v-layout>
</template>


<script>
   import formatDate from "@/utilities/formatDate.js"

   export default {

      props: {
         userId: Number,
      },

      mounted: function() {
         // fetch user history in central store: reactivity will update the list view
         this.$store.dispatch('GET_USER_HISTORY_EVENTS', this.userId)
      },

      data () {
         return {
         }
      },

      computed: {
         user () {
            return this.$store.state.users[this.userId]
         },
         events () {
            if (this.$store.state.user2eventList.hasOwnProperty(this.userId)) {
               return this.$store.state.user2eventList[this.userId].map(eventId => this.$store.state.events[eventId])
            } else {
               return []
            }
         },
      },

      methods: {
         formatDate (date) {
            return formatDate(date)
         },
         eventAuthorName (event) {
            if (this.$store.state.users.hasOwnProperty(event.author)) {
               let author = this.$store.state.users[event.author]
               return author.first_name + ' ' + author.last_name
            } else {
               return ''
            }
         },
      },
   };
</script>


<style scoped lang="scss" type="text/scss">

.padded {
	padding: 20px;
}

.message-text {
   padding-left: 18px;
   padding-right: 18px;
   padding-top: 10px;
   padding-bottom: 10px;
   margin-top: 3px;
   margin-bottom: 15px;
   border-radius: 18px;
}

.message-author {
   color: #444444;
   font-size: 0.9em;
}

.message-date {
   color: #888888;
   font-size: 0.8em;
}

</style>



// WEBPACK FOOTER //
// UserHistory.vue?4289c184